<template>
  <v-list v-if="jobs.length > 0" class="py-0" dense>
    <v-list-item
      v-for="(job, index) in jobs"
      :key="job.id"
      :divider="index < jobs.length - 1"
      dense
    >
      <v-list-item-content dense>
        <v-list-item-title class="d-flex align-center flex-wrap" dense>
          <span class="font-weight-medium text--primary">[{{ getJobSequence(job.id) }}] {{ formatJobKinds(job.jobKinds) }}</span>
          <v-tooltip
            v-if="job.samplingFlag"
            bottom
            max-width="280"
          >
            <template #activator="{ on, attrs }">
              <v-chip
                small
                outlined
                color="info"
                class="ml-2 my-0"
                v-bind="attrs"
                v-on="on"
              >
                {{ $t('aiJob.samplingChip') }}
              </v-chip>
            </template>
            <span>{{ $t('aiJob.samplingRunTooltip') }}</span>
          </v-tooltip>
          <v-spacer />
          <v-chip
            v-if="showJobStatus"
            small
            :color="getStatusColor(job.processStatus)"
            text-color="text"
            class="mr-2"
          >
            {{ getStatusText(job.processStatus) }}
          </v-chip>
          <v-btn
            v-if="job.processStatus === 'ING' && showCancelButton"
            small
            outlined
            class="solvit-crud-outline-btn solvit-crud-outline-btn--danger"
            :loading="cancellingJobId === job.id"
            @click="$emit('cancel', job.id)"
          >
            <v-icon left small>mdi-cancel</v-icon>
            {{ $t('common.cancel') }}
          </v-btn>
        </v-list-item-title>
        <v-list-item-subtitle
          v-if="job.jobFailReason"
          class="text--secondary"
          dense
        >
          <div class="error--text">
            <strong>{{ $t('aiJob.failReason') }}</strong> {{ job.jobFailReason }}
          </div>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'RunningJobItemList',
  props: {
    jobs: {
      type: Array,
      required: true
    },
    cancellingJobId: {
      type: Number,
      default: null
    },
    getJobSequence: {
      type: Function,
      required: true
    },
    formatJobKinds: {
      type: Function,
      required: true
    },
    formatProgress: {
      type: Function,
      required: true
    },
    getStatusColor: {
      type: Function,
      required: true
    },
    getStatusText: {
      type: Function,
      required: true
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showJobStatus: {
      type: Boolean,
      default: true
    }
  }
};
</script>

